import React from 'react';

function AuthBackground() {
   return (
      <div className="absolute inset-0 overflow-hidden">
         <div className="absolute top-0 left-0 w-96 h-96 bg-amethyst/10 rounded-full filter blur-3xl animate-pulse-glow"></div>
         <div
            className="absolute bottom-0 right-0 w-96 h-96 bg-rose/10 rounded-full filter blur-3xl animate-pulse-glow"
            style={{ animationDelay: '1s' }}
         ></div>
      </div>
   );
}

export default AuthBackground;
